import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import { reducer } from './reducer';
import { getInitialState } from '../methods/getInitialState';
import { settings } from '../context/settings';

const initialState = getInitialState();

// Settings.
export const SettingsContext = createContext( settings );

// Data Provider
export const DataContext = createContext();
export const DispatchContext = createContext();
export function DataProvider( props ) {
	const [ state, dispatch ] = React.useReducer( reducer, initialState )

	const { children } = props;

	DataProvider.propTypes = {
		children: PropTypes.element
	}

	return (
		<DataContext.Provider value={ state }>
			<DispatchContext.Provider value={ dispatch }>
				{children}
			</DispatchContext.Provider>
		</DataContext.Provider>
	)
}

export const useSettings = () => React.useContext( SettingsContext );
export const useData = () => React.useContext( DataContext );
export const useDispatch = () => React.useContext( DispatchContext );
export const useStore = () => ({
	state: useData(),
	dispatch: useDispatch(),
});
